import pdpConfig from "./rbmc.pdp-configurator-field";
import productDetails from "./rbmc.pdp";
import pdpAddToCart from './rbmc.pdp-add-to-cart';

const pdpPatches = {
    patchesPanel:            undefined,
    patchesOption:           undefined,
    savePatchChoiceBtn:      undefined,
    resetPatchChoiceBtn:     undefined,
    sponsorPatchPlaceholder: undefined,
    addPatch:                undefined,
    customPatch:             false,
    customPatchFirstTime:    true,

    bindEvents() {
        pdpPatches.addPatch.on('click', function () {
            if (productDetails.mobileActiveFlag) {
                pdpPatches.patchesPanel.removeClass('d-none');

                setTimeout(function () {
                    pdpPatches.patchesPanel.addClass('panelAnimate');
                }, 50);

                setTimeout(function () {
                    pdpConfig.configuratorWrapper.addClass('d-none');
                }, 550);
            } else {
                pdpPatches.patchesPanel.removeClass('d-none');
                pdpConfig.configuratorWrapper.addClass('d-none');
            }
            productDetails.menuOpened = true;
        });

        pdpPatches.savePatchChoiceBtn.on('click',
                pdpPatches.savePatchChoice
        );

        pdpPatches.addPatch.on('click', '.pdp__icon-reset',
                pdpPatches.resetPatchesChoice
        );

        pdpPatches.resetPatchChoiceBtn.on('click', function () {
            pdpPatches.patchesOption.find(':checkbox').prop('checked', false);
        });
    },

    closePatchesPanel() {
        if (productDetails.mobileActiveFlag) {
            pdpPatches.patchesPanel
                      .removeClass('panelAnimate');
            setTimeout(function () {
                pdpPatches.patchesPanel.addClass('d-none');
            }, 500);
            pdpConfig.configuratorWrapper.removeClass('d-none');
        } else {
            pdpPatches.patchesPanel.addClass('d-none');
            pdpConfig.configuratorWrapper.removeClass('d-none');
        }
        productDetails.menuOpened = false;
    },

    setPatchChoice() {
        pdpPatches.patchesOption.on('change', ':checkbox', function () {
            const clickedCheckbox = $(this);
            if (clickedCheckbox.data('patch-exclusive')) {
                pdpPatches.patchesOption.find(':checkbox').not(clickedCheckbox).prop('checked', false);
                pdpPatches.savePatchChoiceBtn.prop('disabled', false);
            } else {
                pdpPatches.patchesOption.find(':checkbox[data-patch-exclusive="true"]')
                          .not(clickedCheckbox).prop('checked', false);
                pdpPatches.savePatchChoiceBtn.prop('disabled', false);
            }
        });
    },

    getSelectedPatchesForForm() {
        let patchesString = [];
        pdpPatches.patchesOption.find('input:checked').each(function (i, patch) {
            patchesString.push(
                    $(patch).attr('id'));
        });
        return patchesString.join(',');
    },

    getCustomPatchChoice() {
        let patchesString = [];
        pdpPatches.patchesOption.find('input:checked').each(function (i, patch) {
            patchesString.push(
                    $(patch).siblings('.pdp__patch-label:first')
                            .find('.pdp__info-patch')
                            .text());
        });
        return patchesString.join(', ');
    },

    savePatchChoice() {
        if (pdpPatches.patchesOption.find('input:checked').length) {
            pdpPatches.sponsorPatchPlaceholder.text(
                    pdpPatches.getCustomPatchChoice()
            );
            pdpPatches.addPatch.find('.pdp__icon-reset').removeClass('d-none');
            pdpPatches.closePatchesPanel();
            productDetails.menuOpened = false;
            pdpPatches.customPatch    = true;
            pdpAddToCart.setPatches(pdpPatches.getSelectedPatchesForForm());
        } else {
            pdpPatches.resetPatchesChoice();
            pdpAddToCart.setPatches('');
        }
    },

    resetPatchesChoice(event) {
        if (event !== undefined) {
            event.stopImmediatePropagation();
        }
        pdpPatches.patchesOption.find('input').prop('checked', false);
        pdpConfig.customPatchField.html(
                pdpConfig.customPatchField.data('default')
        );
        pdpPatches.addPatch.find('.pdp__icon-reset').addClass('d-none');
        pdpPatches.customPatch = false;
        pdpAddToCart.setPatches('');
    },

    leaveNotSaved() {
        pdpPatches.patchesPanel.on('click', '.pdp__icon-back', function () {
            if (pdpPatches.customPatchFirstTime && pdpPatches.patchesOption.find('input').is(':checked')) {
                pdpPatches.patchesPanel.find('.pdp__icon-back').tooltip('show');
                const $pdpPatchesLeave = $('#pdp__tooltip-patches-leave');

                $pdpPatchesLeave.on('click', '.pdp__tooltip-cancel', function () {
                    pdpPatches.patchesPanel.find('.pdp__icon-back').tooltip('hide');
                    pdpPatches.customPatchFirstTime = false;
                    pdpPatches.resetPatchesChoice();
                    pdpPatches.closePatchesPanel();
                });

                $pdpPatchesLeave.on('click', '.pdp__tooltip-confirm', function () {
                    pdpPatches.customPatchFirstTime = false;
                    pdpPatches.patchesPanel.find('.pdp__icon-back').tooltip('hide');
                    pdpPatches.savePatchChoice();
                });
            } else {
                pdpPatches.patchesPanel.find('.pdp__icon-back').tooltip('hide');
                pdpPatches.resetPatchesChoice();
                pdpPatches.closePatchesPanel();
            }
        });

    },

    cacheVariables() {
        pdpPatches.patchesPanel            = $('#pdp__patch-panel');
        pdpPatches.sponsorPatchPlaceholder = $('#pdp__sponsor-patch');
        pdpPatches.savePatchChoiceBtn      = $('#pdp__save-patches');
        pdpPatches.resetPatchChoiceBtn     = $('#pdp__reset-patch-personalization');
        pdpPatches.patchesOption           = $('.pdp__patches-option');
        pdpPatches.addPatch                = $('#pdp__add-patch');
    },

    init() {
        pdpPatches.cacheVariables();
        pdpPatches.bindEvents();
        pdpPatches.setPatchChoice();
        pdpPatches.leaveNotSaved();
    }
};

export default pdpPatches;
